import { forwardRef } from 'react';
import { cn } from '../utils/cn';

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
  label?: string;
}

export const Divider = forwardRef<HTMLDivElement, DividerProps>(function Divider(
  { orientation = 'horizontal', label, className, ...rest },
  ref,
) {
  if (label) {
    return (
      <div
        ref={ref}
        role="separator"
        aria-orientation="horizontal"
        className={cn('flex items-center gap-2', className)}
        {...rest}
      >
        <span className="h-px flex-1 bg-[var(--color-border-subtle)]" />
        <span className="text-micro font-semibold uppercase tracking-eyebrow text-content-muted">
          {label}
        </span>
        <span className="h-px flex-1 bg-[var(--color-border-subtle)]" />
      </div>
    );
  }

  return (
    <div
      ref={ref}
      role="separator"
      aria-orientation={orientation}
      className={cn(
        'bg-[var(--color-border-subtle)]',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px self-stretch',
        className,
      )}
      {...rest}
    />
  );
});
